__turbopack_context__.v({
  "avatar": "AvatarGroup-module-scss-module__aKX5rq__avatar",
  "avatarGroup": "AvatarGroup-module-scss-module__aKX5rq__avatarGroup",
  "item": "AvatarGroup-module-scss-module__aKX5rq__item",
  "lg": "AvatarGroup-module-scss-module__aKX5rq__lg",
  "md": "AvatarGroup-module-scss-module__aKX5rq__md",
  "sm": "AvatarGroup-module-scss-module__aKX5rq__sm",
  "xl": "AvatarGroup-module-scss-module__aKX5rq__xl",
  "xs": "AvatarGroup-module-scss-module__aKX5rq__xs",
});
